import { Pipe, PipeTransform } from "@angular/core";
import { defaultIds } from "@app/pages/settings/workspaces/workspace-page/tabs/edit-tab/sections/detail/absence-subcategory/absence-category-form/absence-category-form.types";
import { TranslateService } from "@ngx-translate/core";

// const defaultIds = [
// 	"00000000-0000-0000-0000-000000000000",
// 	"00000000-0000-0000-0000-111111111111",
// 	"00000000-0000-0000-0000-222222222222",
// 	"00000000-0000-0000-0000-333333333333",
// 	"00000000-0000-0000-0000-444444444444",
// 	"00000000-0000-0000-0000-555555555555",
// 	"00000000-0000-0000-0000-666666666666",
// 	"00000000-0000-0000-0000-777777777777",
// ];

@Pipe({
	name: "absenceTranslate",
	pure: false,
})
export class AbsenceTranslatePipe implements PipeTransform {
	constructor(private translate: TranslateService) {}
	transform(absence: any): string {
		const absenceName = absence?.title ?? absence.name;
		if (defaultIds.includes(absence.id)) return this.translate.instant(absenceName);
		return absenceName;
	}
}
